import type { SimulationNodeDatum, SimulationLinkDatum } from 'd3-force';
import type { SearchResult, Tier } from './types';

export interface GraphNode extends SimulationNodeDatum {
  id: string;
  title: string;
  tier: Tier | string;
  isSeed: boolean;
}

export interface GraphEdge extends SimulationLinkDatum<GraphNode> {
  source: string | GraphNode;
  target: string | GraphNode;
}

export interface GraphData {
  nodes: GraphNode[];
  edges: GraphEdge[];
}

export function deriveGraph(results: SearchResult[]): GraphData {
  const nodeMap = new Map<string, GraphNode>();
  const edgeKeys = new Set<string>();
  const edges: GraphEdge[] = [];

  for (const r of results) {
    const isSeed = !r.traversed_from;
    const existing = nodeMap.get(r.slug);
    if (!existing) {
      nodeMap.set(r.slug, {
        id: r.slug,
        title: r.title,
        tier: r.tier,
        isSeed,
      });
    } else if (isSeed) {
      existing.isSeed = true;
    }
  }

  for (const r of results) {
    if (!r.traversed_from) continue;
    if (!nodeMap.has(r.traversed_from) || !nodeMap.has(r.slug)) continue;
    const key = `${r.traversed_from}->${r.slug}`;
    if (edgeKeys.has(key)) continue;
    edgeKeys.add(key);
    edges.push({ source: r.traversed_from, target: r.slug });
  }

  return { nodes: [...nodeMap.values()], edges };
}
